<script>
    import useTaskDelivery from '../data-views/activation-briefs/composables/use-task-delivery';
    import ActivationBriefMixin from '../providers/mixins/ActivationBriefMixin';
    import { useContactStore, useFeatureFlagsStore } from '../../../stores';
    import useRouter from '../../../src/composables/use-router';
    import ActivationBriefTasksMixin from '../providers/mixins/ActivationBriefTasksMixin';

    export default {
        name: 'ActivationBriefDeliveryPageRedirectionView',
        mixins: [ActivationBriefTasksMixin, ActivationBriefMixin],
        computed: {
            contactId() {
                const { data: contact } = useContactStore();
                return contact?.id;
            },
            isTasklessRedirect() {
                // Check if this is a taskless redirect (no task_id in route)
                return !this.$route.params.task_id;
            }
        },
        setup() {
            const featureFlags = useFeatureFlagsStore().data;
            const showCreatorContentMetrics = featureFlags['creator-content-metric-screenshots'] || false;
            const router = useRouter().get();
            const { goToDeliveryPage } = useTaskDelivery();

            const redirect = (task) => {
                if (showCreatorContentMetrics) {
                    router.push({
                        name: 'v2.activation.brief.task.content',
                        params: {
                            brief_id: task.brief_id,
                            task_id: task.id
                        }
                    });
                } else {
                    goToDeliveryPage(task, true, { id: task.deliverable_id });
                }
            };

            const redirectToTasklessContent = (briefId) => {
                // For taskless content, redirect to the brief overview/tasks page
                // where creators can see their content without tasks
                router.push({
                    name: 'v2.activation.brief.tasks',
                    params: {
                        brief_id: briefId
                    }
                });
            };

            return {
                redirect,
                redirectToTasklessContent,
                showCreatorContentMetrics
            };
        },
        async mounted() {
            await this.loadActivationBrief(true);

            if (this.isTasklessRedirect) {
                // Handle taskless content redirect
                this.$nextTick(() => {
                    this.redirectToTasklessContent(this.briefParamId);
                });
            } else {
                // Handle task-based content redirect (existing logic)
                const task = this.brief.tasks.find((t) => t.id === Number(this.taskParamId));

                this.$nextTick(() => {
                    this.redirect(task);
                });
            }
        }
    };
</script>
